import React from "react"
import { RouteComponentProps } from "@reach/router"

import { AuthenticatedApolloProvider } from "./context/AuthenticatedApolloProvider"
import { AuthenticatedContextProvider } from "./context/AuthenticatedContext"
import AuthorizationErrorBoundary from "./errors/AuthorizationErrorBoundary"
import { UserContextProvider } from "./context/UserContext"
import ScopeSelector from "./pages/Scopes/ScopeSelector"
import { LayoutContextProvider } from "./context/LayoutContext"
import { GlobalSearchContextProvider } from "./context/GlobalSearchContext"
import { RankingDateContextProvider } from "./context/RankingDateContext"
import { LayoutErrorBoundary } from "./errors/LayoutErrorBoundary"
import { QueuedJobsContextProvider } from "./context/QueuedJobsContext"

const Authenticated: React.FC<RouteComponentProps> = () => {
	return (
		<AuthenticatedContextProvider>
			<AuthenticatedApolloProvider>
				<UserContextProvider>
					<RankingDateContextProvider>
						<GlobalSearchContextProvider>
							<LayoutContextProvider>
								<LayoutErrorBoundary>
									<AuthorizationErrorBoundary>
										<QueuedJobsContextProvider>
											<ScopeSelector />
										</QueuedJobsContextProvider>
									</AuthorizationErrorBoundary>
								</LayoutErrorBoundary>
							</LayoutContextProvider>
						</GlobalSearchContextProvider>
					</RankingDateContextProvider>
				</UserContextProvider>
			</AuthenticatedApolloProvider>
		</AuthenticatedContextProvider>
	)
}

export default Authenticated
